import React from 'react';

const STATUS_CONFIG = {
  DRAFT:     { label: 'Brouillon',   color: 'bg-gray-100 text-gray-700' },
  SUBMITTED: { label: 'Soumise',     color: 'bg-yellow-100 text-yellow-800' },
  VALIDATED: { label: 'Validée',     color: 'bg-blue-100 text-blue-800' },
  SIGNING:   { label: 'En signature', color: 'bg-purple-100 text-purple-800' },
  SIGNED:    { label: 'Signée',      color: 'bg-green-100 text-green-800' },
  ARCHIVED:  { label: 'Archivée',    color: 'bg-gray-200 text-gray-600' },
  REJECTED:  { label: 'Rejetée',     color: 'bg-red-100 text-red-800' },
};

export default function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, color: 'bg-gray-100 text-gray-700' };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      {config.label}
    </span>
  );
}
